<template>
  <section class="medium">
    <h3 class="">Opleverwijze</h3>
    <ul>
      <li v-if="order.medium.isEmail">
        Via e-mail: {{ order.medium.emailAddress }}
      </li>
      <li v-if="order.medium.isDisk">Op schijf (usb of hdd)</li>
      <li v-if="order.medium.isFileStore">Archief in FileStore</li>
      <li v-if="order.medium.isOther">Zie instructies</li>
    </ul>
  </section>
</template>

<script>
export default {
  props: ['order']
}
</script>

<style lang="scss">
h3 {
  font-weight: 600;
}
</style>
